import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable } from 'rxjs';
import { EnvironmentService } from './environment.service';
import { HeroResponse } from '../models';
import { RemoteConfigService } from './remote-config.service';

const DEFAULT_HEROES_VERSION = '7';

@Injectable({
    providedIn: 'root'
})
export class HeroService {

    constructor(
        private envService: EnvironmentService,
        private config: RemoteConfigService,
        private http: HttpClient) {
    }

    /** Hero API version from remote config (heroes_version), mirroring the web app. */
    private get apiVersion(): string {
        return this.config.remoteConfig?.heroes_version || DEFAULT_HEROES_VERSION;
    }

    getHeroV5Auth(): Observable<HeroResponse> {
        const v = this.apiVersion;
        return this.http.get<HeroResponse>(`${this.envService.contentHost}/v${v}/hero/auth?supportVersion=${v}&platform=stv`)
    }

    getHeroV5Anon(): Observable<HeroResponse> {
        const v = this.apiVersion;
        return this.http.get<HeroResponse>(`${this.envService.contentHost}/v${v}/hero/anon?supportVersion=${v}&platform=stv`)
    }
}
